export enum EAnalyticsIntegrationType{
    Direct,
    RudderStack
}
